import { AdData, MapOfBrands, ProductData } from "~src/types/brandMapping";

export const dateFormatter = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const monthName = date.toLocaleString("default", {
    month: "short",
  });
  const year = date.getFullYear();
  const formattedDate = `${monthName} ${day},  ${year}`;
  return formattedDate;
};

export const brandConfig = (brand: MapOfBrands | undefined) => {
  if (!brand) return null;
  let minPrice = Infinity;
  let maxPrice = -Infinity;

  const productImageUrls: ProductData[] = [];
  const adImageUrls: AdData[] = [];

  for (const product of brand.products) {
    if (product.price != null) {
      minPrice = Math.min(minPrice, product.price);
      maxPrice = Math.max(maxPrice, product.price);
    }
    if (product) {
      productImageUrls.push(product);
    }
  }

  for (const ad of brand.ads) {
    if (ad) {
      adImageUrls.push(ad);
    }
  }

  const priceRange = {
    min: minPrice === Infinity ? 0 : minPrice,
    max: maxPrice === -Infinity ? "-" : maxPrice,
  };
  return { productImageUrls, adImageUrls, priceRange };
};
